module.exports = __webpack_public_path__ + "static/media/ps.2992f9b9.svg";